import React from 'react';
import { ColorCheckbox } from '../../ui/ColorCheckbox';
import { InfoTip } from '../../ui/InfoTip';
export type CategoryTone = 'orange' | 'teal' | 'pink' | 'green';
const tones: Record<CategoryTone, {
  bg: string;
  border: string;
  check: string;
}> = {
  orange: {
    bg: '#fcf0dc',
    border: '#f5a623',
    check: '#f59f1a'
  },
  teal: {
    bg: '#c8f5ea',
    border: '#30d3b1',
    check: '#52d6bd'
  },
  pink: {
    bg: '#fce1f3',
    border: '#ec2fc0',
    check: '#e81fbf'
  },
  green: {
    bg: '#e2f8e1',
    border: '#2ec22e',
    check: '#22b922'
  }
};
type SupportCategoryProps = {
  tone: CategoryTone;
  label: string;
  icon: React.ReactNode;
  checked: boolean;
  onToggle: (checked: boolean) => void;
  children?: React.ReactNode;
};
export function SupportCategory({
  tone,
  label,
  icon,
  checked,
  onToggle,
  children
}: SupportCategoryProps) {
  const t = tones[tone];
  return <div className="mt-[5px] rounded-[3px] border px-[7px]" style={{
    backgroundColor: t.bg,
    borderColor: t.border
  }} data-id="element-597" data-mp="ex9pvxz0j85y">
      <div className="flex h-[23px] items-center gap-[6px]" data-id="element-598" data-mp="ayty7grzlbm7">
        <ColorCheckbox label={label} checked={checked} color={t.check} onChange={onToggle} data-id="element-599" data-mp="3f6dud0gf7nyq" />
        <span className="h-[13px] w-[13px] text-[#5d6268]" data-id="element-600" data-mp="3jynqwzc1jm9z">{icon}</span>
        <span className="text-[12.5px] font-bold text-[#575c62]" data-id="element-601" data-mp="359hs3ch47y2m">{label}</span>
        <InfoTip label={`About ${label}`} data-id="element-602" data-mp="3a82k4om7rbfz" />
      </div>
      {children && <div className={`pb-[4px] pl-[38px] transition-opacity duration-150 ${checked ? 'opacity-100' : 'pointer-events-none opacity-40'}`} data-id="element-603" data-mp="3a8cdmm6gw0qf">
          {children}
        </div>}
    </div>;
}